<div id="img-cont" class="dsk">
    <!-- <img src="../../../assets/logo_msh@2x.png" alt="" class="logo-meity" matTooltip="* All Names and Images used are for Graphical Representation">
    <b class="bold">*</b>
    <img style="margin-left: 20px;"
    src="../../../assets/meta-logo-primary_standardsize.svg" alt="" class="logo-meta" matTooltip="* All Names and Images used are for graphical representation">
    <b style="margin-right: 20px;">*</b> -->
    <img style="margin-left: 20px;" src="../../../assets/Incubator.svg" alt="" class="logo-inc">
</div>

<div class="glass">
</div>
<div id="mb-logos" class="mb">
</div>